// Мапперы для категорий согласно STYLEGUIDE.md (snake_case <-> camelCase)

import { Category, DbCategory, CategoryCreate, CategoryUpdate } from '@/types/entities/category';

/**
 * Конвертирует категорию из БД формата в frontend формат
 * @param dbCategory - категория в формате БД (snake_case)
 * @returns категория в формате frontend (camelCase)
 */
export function dbCategoryToCategory(dbCategory: DbCategory): Category {
  return {
    id: dbCategory.id,
    userId: dbCategory.user_id,
    createdAt: new Date(dbCategory.created_at),
    updatedAt: new Date(dbCategory.updated_at),
    name: dbCategory.name,
    description: dbCategory.description,
    type: dbCategory.type,
    parentId: dbCategory.parent_id,
  };
}

/**
 * Конвертирует категорию из frontend формата в БД формат
 * @param category - категория в формате frontend (camelCase)
 * @returns категория в формате БД (snake_case)
 */
export function categoryToDbCategory(category: Category): DbCategory {
  return {
    id: category.id,
    user_id: category.userId,
    created_at: category.createdAt.toISOString(),
    updated_at: category.updatedAt.toISOString(),
    name: category.name,
    description: category.description,
    type: category.type,
    parent_id: category.parentId,
  };
}

/**
 * Конвертирует данные создания категории из frontend в БД формат
 * @param categoryData - данные для создания категории
 * @param userId - ID пользователя
 * @returns данные в формате БД для создания
 */
export function categoryCreateToDbCreate(
  categoryData: Omit<Category, 'id' | 'userId' | 'createdAt' | 'updatedAt'>,
  userId: string
): CategoryCreate {
  return {
    user_id: userId,
    name: categoryData.name,
    description: categoryData.description,
    type: categoryData.type,
    parent_id: categoryData.parentId,
  };
}

/**
 * Конвертирует данные обновления категории из frontend в БД формат
 * @param categoryData - данные для обновления категории
 * @returns данные в формате БД для обновления
 */
export function categoryUpdateToDbUpdate(
  categoryData: Partial<Omit<Category, 'id' | 'userId' | 'createdAt' | 'updatedAt'>>
): CategoryUpdate {
  const dbUpdate: CategoryUpdate = {};
  
  if (categoryData.name !== undefined) dbUpdate.name = categoryData.name;
  if (categoryData.description !== undefined) dbUpdate.description = categoryData.description;
  if (categoryData.type !== undefined) dbUpdate.type = categoryData.type;
  if (categoryData.parentId !== undefined) dbUpdate.parent_id = categoryData.parentId;
  
  return dbUpdate;
}
